module.exports = __webpack_public_path__ + "img/diagram-nested.bf379074.svg";